function MonthlyIncomeSummary() {
  return (
    <div>
      <h2>Monthly Income Summary</h2>
      <p>Your complete information comes here.</p>
    </div>
  );
}

export default MonthlyIncomeSummary;